export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;

export const selectUser = (state) => state.auth.user;

export const selectBoater = (state) => state.auth.boater;

export const selectLoginError = (state) => state.auth.loginError;


